import { TFunction } from "i18next";
import { ChannelSend, FrequencySend } from "../enums/tabs";

export interface ChannelOption {
    value: string;
    label: string;
    id: string;
    check: boolean;
}

export const channelSending = (t: TFunction): ChannelOption[] => {

    return [
        {
            id: String(ChannelSend.EMAIL),
            label: t('reportFolio.notificationCenter.channelSending.email'),
            value: String(ChannelSend.EMAIL),
            check: false
        },
        {
            id: String(ChannelSend.APP),
            label: t('reportFolio.notificationCenter.channelSending.mobileApplication'),
            value: String(ChannelSend.APP),
            check: false
        }
    ]
}

export const frequencySending = (t: TFunction): ChannelOption[] => {

    return [
        {
            id: String(FrequencySend.DAILY),
            label: t('reportFolio.notificationCenter.frequencySending.endOfTheDay'),
            value: String(FrequencySend.DAILY),
            check: false
        },
        {
            id: String(FrequencySend.EVERYTHREEDAYS),
            label: t('reportFolio.notificationCenter.frequencySending.everyThreeDays'),
            value: String(FrequencySend.EVERYTHREEDAYS),
            check: false
        },
        {
            id: String(FrequencySend.WEEKLY),
            label: t('reportFolio.notificationCenter.frequencySending.everyWeek'),
            value: String(FrequencySend.WEEKLY),
            check: false
        }
    ]
}



